/**
 * Make a non-button element (e.g. an animated card) behave like a link/button
 * for keyboard and screen-reader users: focusable, named, Enter/Space activate.
 *
 *   <motion.div {...pressable(() => navigate(url), `Open ${movie.title}`)} />
 */
export function pressable(onActivate, label, role = 'link') {
  return {
    role,
    tabIndex: 0,
    'aria-label': label,
    onClick: onActivate,
    onKeyDown: (e) => {
      if (e.key === 'Enter' || (role === 'button' && e.key === ' ')) {
        e.preventDefault();
        onActivate(e);
      }
    },
  };
}
